import React, { Fragment, useState, useRef } from "react";
import _ from "lodash";
import RegisterFields from "../RegisterFields";
import saleFormFields from "./saleFormFields";

export const SaleForm = (props) => {
  const inputRef = useRef({});

  const renderFields = () => {
    return _.map(saleFormFields, ({ label, name, type, options, required }) => {
      return (
        <RegisterFields
          key={name}
          name={name}
          label={label}
          type={type}
          value={inputRef.current[name]}
          options={options}
          required={required}
          onChange={props.onChange(name)}
        />
      );
    });
  };

  return <Fragment>{renderFields()}</Fragment>;
};
